export enum ExternalLink {
    PRIVACY = 'https://badoo.com/privacy',
    TERMS = 'https://badoo.com/terms',
    SAFETY_CENTRE = 'https://badoo.com/safety-centre',
    APP_STORE_ANDROID = 'https://badoo.com/install/?ref=web-direct-footer&d=Android',
    APP_STORE_IOS = 'https://badoo.com/install/?ref=web-direct-footer&d=Iphone',
    APP_STORE_HUAWEI = 'https://appgallery.huawei.com/app/C104563545',
}
